import React from 'react'
import '../Pages.css'

function ContactUs() {

  function improvement(name, desc) {
    return (
      <div className="improv">
        <h3>{name}</h3>
        <p>{desc}</p>
      </div>
    )
  }

  return (
    <div id='contact-us'>
      <h1>EXCITING THINGS ARE COMING!</h1>
      <p>We hope that the vision loss hub becomes a valuable resource for those with sight loss to find help they need, a community they want and a wealth of information they can share. With that in mind we know this website requires more work, so far we have the following improvements in mind:</p>
      {improvement(
        'Accessibilty',
        'Obviously this is the highest priority but first we are working on ensuring there is content worth the effort of reading!'
      )}
      {improvement(
        'Benefits',
        'We hope to break down all of the benefits the visually impaired community are entitled to. For now we are able to discuss most of these during our signposting service but we hope to house reference points here in the future.'
      )}
      {improvement(
        'Mobility Advice',
        'While some of this has been implemented in the section shown it is clear there are much more resources available. This list will grow as we do. Our proposed list so far also include Passenger Assistance available on planes and trains, Guide Dogs, and various schemes that allow people to apply for companion tickets, enabling a guide to join, at no additional cost, visually impaired people so they can enjoy social events without breaking the bank.'
      )}
      {improvement(
        'Health and Wellbeing',
        'Visual impairments result from a mryiad of conditions, we hope this area will provide a directory of references where more infomation can be found to improve awareness or support to individual conditions opposed to the blanket affliction of vision loss.'
      )}
      {improvement(
        'Supporting VIPs',
        'While we support those with sight loss we must always champion those who help them. As members of the VI community ourselves we are aware that it does also impact those around us and are forever grateful to family and friends who are there for us, but they deserve help too.'
      )}
      {improvement(
        'Peer Support',
        'Being visually impaired can feel isolating, leaving you cut off from living life, but given some courage and directions to a friendly group it is possible to become a social butterfly. Here we hope to have a notice board of sorts where social groups can advertise their contacts and you can pick the best ones for you, or try them all for some variety!'
      )}
      <p>These are just the ideas we have in the works for now, (I'm trying my best I promise! - IT Guy) but we would also appreciate any feedback or suggestions that would improve this site please feel free to message us. Our details can be found in the black banner at the bottom of each page, or you can let one of our team know at the vision loss hub open days, last Tuesday of each month at the Alice Wheeldon room, Derby Council House.</p>
    </div>
  )
}

export default ContactUs